import React, { } from "react";
import { Button, Tag } from "antd";
import { Droppable } from "react-drag-and-drop";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutlined } from "@ant-design/icons";
import { setCompare1, setCompare2, setCompareResultTab } from "../../../store/components/Insights.slice";

function ReportBuilderComparePage() {
    const dispatch = useDispatch();

    const {
        compare1, compare2, compareResultTab
    } = useSelector((state) => state.insights);

    return (
        <div className="reportBuilder_targets_compare d-flex-col gap-1">
            <p>You can only compare two behaviors at a time.</p>
            <div className="reportBuilder_targets_compare_container">
                <div className="reportBuilder_targets_compare_item">
                    <span>Behavior 1</span>
                    <Droppable
                        types={["behavior"]}
                        onDrop={(e) => {
                            const data = JSON.parse(e.behavior);
                            if (compare2 && compareResultTab !== "compareresult") {
                                dispatch(setCompareResultTab("compareresult"));
                            }
                            dispatch(setCompare1(data));
                        }}
                    >
                        <div
                            className="reportBuilder_targets_compare_drop"
                        >
                            {compare1?.item
                                ? (
                                    <>
                                        <Tag
                                            style={{
                                                color: compare1.color,
                                                borderColor: compare1.color,
                                                background: compare1.bg,
                                                borderRadius: "50px",
                                                padding: "1mm 2mm"
                                            }}
                                        >
                                            {compare1?.item}
                                        </Tag>
                                        <Button
                                            style={{ display: "none" }}
                                            danger
                                            className="drop-delete"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (compareResultTab !== "deepdive") {
                                                    dispatch(setCompareResultTab("deepdive"));
                                                }
                                                dispatch(setCompare1(null));
                                            }}
                                            icon={<DeleteOutlined style={{ fontSize: "15px" }} />}
                                            type="link"
                                        />
                                    </>
                                )
                                : <span className="reportBuilder_targets_compare_placeholder">Drag and drop category/behavior here.</span>}
                        </div>
                    </Droppable>
                </div>
                <span>versus</span>
                <div className="reportBuilder_targets_compare_item">
                    <span>Behavior 2</span>
                    <Droppable
                        types={["behavior"]}
                        onDrop={(e) => {
                            const data = JSON.parse(e.behavior);
                            if (compare1 && compareResultTab !== "compareresult") {
                                dispatch(setCompareResultTab("compareresult"));
                            }
                            dispatch(setCompare2(data));
                        }}
                    >
                        <div
                            className="reportBuilder_targets_compare_drop"
                        >
                            {compare2?.item
                                ? (
                                    <>
                                        <Tag
                                            style={{
                                                color: compare2.color,
                                                borderColor: compare2.color,
                                                background: compare2.bg,
                                                borderRadius: "50px",
                                                padding: "1mm 2mm"
                                            }}
                                        >
                                            {compare2?.item}
                                        </Tag>
                                        <Button
                                            style={{ display: "none" }}
                                            danger
                                            className="drop-delete"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (compareResultTab !== "deepdive") {
                                                    dispatch(setCompareResultTab("deepdive"));
                                                }
                                                dispatch(setCompare2(null));
                                            }}
                                            icon={<DeleteOutlined style={{ fontSize: "15px" }} />}
                                            type="link"
                                        />
                                    </>

                                )
                                : <span className="reportBuilder_targets_compare_placeholder">Drag and drop category/behavior here.</span>}

                        </div>
                    </Droppable>
                </div>
            </div>
        </div>
    );
}
export default ReportBuilderComparePage;
